import { x } from '@xstyled/styled-components';
import React, { FC } from 'react';
import { useSpring } from '@react-spring/web';
import ChevronIcon from '~/assets/icons/chevron.svg';
import { Chevron } from './Chevron';

export const FaqItem: FC<{
  title: string;
  expanded?: boolean;
  onClick: () => void;
  children: React.ReactNode;
}> = ({ title, expanded, onClick, children }) => {
  const props = useSpring({
    to: { transform: !expanded ? 'rotate(90deg)' : 'rotate(-90deg)' },
    from: { transform: 'rotate(90deg)' }
  });

  return (
    <>
      <x.button
        border="none"
        bg={expanded ? 'accentDark' : 'transparent'}
        color={expanded ? 'white' : 'black'}
        p={expanded ? 'sm md' : 'sm 0'}
        m={expanded ? '0 -md' : '0'}
        textAlign="left"
        display="flex"
        borderRadius="md"
        onClick={onClick}
        className="itemStyleForDarkTheme"
        aria-expanded={expanded ? 'true' : 'false'}
      >
        <x.span flex="1">{title}</x.span>
        <Chevron style={props}>
          <ChevronIcon />
        </Chevron>
      </x.button>
      {expanded && <div aria-live="polite">{children}</div>}
    </>
  );
};
